import { SidebarSection } from "@salestrak/ui";

import { useFavoriteIssues } from "#app/lib/hooks/use-favorite-issues";

import { FavoriteIssueRows } from "./favorites-section";

/**
 * Home's "Favorites" module-menu section. A project row wears its stage pie.
 * Renders nothing when the user has no favorites; HomeModuleMenu also drops it
 * from its section list in that case so ModuleMenu doesn't draw a stray
 * divider.
 */
export function HomeFavoritesSection() {
  const { sidebarRows: favoriteIssues } = useFavoriteIssues();

  if (favoriteIssues.length === 0) return null;

  return (
    <SidebarSection title="Favorites">
      <FavoriteIssueRows />
    </SidebarSection>
  );
}
